import React from "react";

import { keyPressHelper } from "@helpers/accessibility";
import {
  getFilenameSansExt,
  handleThumbnailError
} from '@components/asset/modal/tabs/edit/helpers';
import Tooltip from "../common/tooltip/main";

export default class Attachment extends React.Component {
  handleClick = () => {
    if (!this.props.placing_file) {
      this.props.showProgressBar();
      // will be defined on the window at runtime
      // eslint-disable-next-line no-undef
      placeRemoteFile(this.props.attachment);
    }
  };

  render() {
    const { extension, filename, thumbnail_url } = this.props.attachment;
    const tooltipId = `adobe-attachment-tooltip-${thumbnail_url}`;
    return (
      <div
        className="adobe-attachment"
        onClick={this.handleClick}
        onKeyPress={keyPressHelper(this.handleClick)}
        tabIndex="0"
        role="button"
      >
        <Tooltip
          offset="{'right': 50}"
          placement="bottom"
          tooltipId={tooltipId}
          tooltipContent={filename}
        >
          <img
            alt={filename}
            className="adobe-attachment-thumbnail"
            onError={(event) => {
              handleThumbnailError(
                event,
                extension,
                getFilenameSansExt(filename, extension)
              );
            }}
            ref="image" // eslint-disable-line react/no-string-refs
            src={thumbnail_url}
          />
        </Tooltip>
      </div>
    );
  }
}
